S.listevent = {
    config: {
        filter: 0,
        action: 'list',
    },

    elements: {
        $listContainer: null,
        $loadButton: null,
        $showAllFilter: null,
        $button: null,
        $teaser: null,
        $filter: null,
        $widthFilter: null,
    },

    originFilter: null,
    currentFilter: null,
    page: null,
    renewList: true,

    init()
    {
        // set initial value for next page to load
        if (!this.page)
        {
            this.page = 2;
        }
        this.originFilter = this.elements.$listContainer.data('type');


        if (this.config.action === 'filter')
        {
            this.elements.$loadButton.on('click', () =>
            {
                this.renewList = false;
                this.currentFilter = this.elements.$listContainer.data('type');
                this.loadEvents();
                this.page++;
            });
        }

        this.initFilters();
        this.elements.$widthFilter.children().eq(0).css('width', this.elements.$widthFilter.children().eq(1).width() + 80);
    },

    loadEvents()
    {
        const container = this.elements.$listContainer;
        const loadButton = this.elements.$loadButton;
        const ajaxUrl = container.attr('data-ajaxUrl');
        const storagePid = container.attr('data-storagepid');
        const data = {};

        data['tx_project_eventfilter[page]'] = this.page;
        data['tx_project_eventfilter[type]'] = this.currentFilter;
        data['tx_project_eventfilter[more]'] = true;
        data['tx_project_eventfilter[storagePid]'] = storagePid;
        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: data,
            cache: false,
            success: (data) =>
            {
                // HTML Output
                if (this.renewList)
                {
                    container.html($(data).find('.m-main-filter').html());
                    this.page++;
                }
                else
                {
                    container.append($(data).find('.m-main-filter').html());
                }
                if ($(data).find('.m-load-button').hasClass('is-hidden'))
                {
                    loadButton.hide();
                }
                else
                {
                    loadButton.show();
                }
            },
            error: (e) =>
            {
                // eslint-disable-next-line no-console
                console.log(e, 'error');
            },
        });
    },

    initFilters()
    {
        this.elements.$button.on('click', (e) =>
        {
            this.page = 1;
            this.renewList = true;
            if ($(e.target).hasClass('is-active'))
            {
                $(e.target).removeClass('is-active');
                this.resetFilter();
                this.getFilterTypes();
            }
            else
            {
                /*
                this.elements.$button.each(function ()
                {
                    $(this).removeClass('is-active');
                });
                */

                $(e.target).addClass('is-active');
                const $that = $(e.target);

                this.elements.$listContainer.data('type', $that.data('filter'));
                this.currentFilter = $that.data('filter');

                if (this.config.action === 'filter')
                {
                    this.getFilterTypes();
                }
                else if (this.config.action === 'list')
                {
                    this.elements.$teaser.removeClass('is-hidden');
                    this.elements.$teaser.each((key, e) =>
                    {
                        const eventTypes = $(e).attr('data-type').split(' ');

                        if (!eventTypes.includes($that.data('filter').toString()))
                        {
                            $(e).addClass('is-hidden');
                        }
                    });
                }
            }

            this.checkColor();
            this.elements.$teaser.each(function ()
            {
                $(this).addClass('is-hidden');
            });
            this.elements.$button.each(function ()
            {
                if ($(this).hasClass('is-active'))
                {
                    S.listevent.displayFilter($(this).attr('data-filter'));
                }
            });
            if (!this.elements.$button.hasClass('is-active'))
            {
                this.resetFilter();
            }
        });
    },

    displayFilter($filter)
    {
        this.elements.$teaser.each(function ()
        {
            if ($(this).attr('data-type') === $filter)
            {
                $(this).removeClass('is-hidden');
            }
        });
    },

    resetFilter()
    {
        this.elements.$listContainer.data('type', this.originFilter);
        this.currentFilter = this.originFilter;

        if (this.config.action === 'filter')
        {
            this.loadEvents();
        }
        else if (this.config.action === 'list')
        {
            this.elements.$teaser.removeClass('is-hidden');
        }
    },

    checkColor()
    {
        let filter = 0;

        this.elements.$filter.children().each(function ()
        {
            $(this).removeClass('is-active is-inactive');
            $(this).has('.is-active').addClass('is-active');
            $(this).not('.is-active').addClass('is-inactive');

            if ($(this).is('.is-active'))
            {
                filter = 1;
            }
        });

        if (!filter)
        {
            this.elements.$filter.children().each(function ()
            {
                $(this).removeClass('is-inactive');
            });
        }
    },
    getFilterTypes()
    {
        let localFilter = '';

        this.elements.$button.each(function ()
        {
            if ($(this).is('.is-active'))
            {
                if (localFilter === '')
                {
                    localFilter = $(this).attr('data-filter');
                }
                else
                {
                    localFilter = $(this).attr('data-filter') + ',' + localFilter;
                }
            }
        });
        this.currentFilter = localFilter;
        this.loadEvents();
    },
};
